const BulkDownloadIcon = (
  <>
    <path
      d="M1.5 11.5V13.2C1.5 13.918 2.08203 14.5 2.8 14.5H8H13.2C13.918 14.5 14.5 13.918 14.5 13.2V11.5"
      stroke="white"
      strokeWidth="1.33"
      strokeLinecap="round"
      fill="transparent"
    />
    <path
      d="M8.33341 6.66667V7H8.66675H11.0001L8.00008 11L5.00008 7H7.33341H7.66675V6.66667V1.66667C7.66675 1.57826 7.70187 1.49348 7.76438 1.43096C7.82689 1.36845 7.91168 1.33333 8.00008 1.33333C8.08849 1.33333 8.17327 1.36845 8.23578 1.43096C8.2983 1.49348 8.33341 1.57826 8.33341 1.66667V6.66667Z"
      fill="white"
      stroke="white"
      strokeWidth="0.666667"
    />
  </>
)

export default BulkDownloadIcon
